import { FC } from 'react';

import { Study } from '@/shared/api/protocol-ts/model/dto_study_pb';
import { Timeline } from '@/shared/ui';

import { useRawMeshViewerTimelineItem } from '../../hooks';
import { RawMeshViewerActionsPopover } from '../RawMeshViewerActionsPopover/RawMeshViewerActionsPopover';

type RawMeshViewerTimelineRowProps = {
  study: Study;
  className?: string;
  testID?: string;
};

export const RawMeshViewerTimelineRow: FC<RawMeshViewerTimelineRowProps> = (
  props,
) => {
  const { study, className, testID } = props;

  const item = useRawMeshViewerTimelineItem(study);

  return (
    <Timeline.Row
      className={className}
      dataComponent="raw-mesh-viewer-timeline-row"
      time={item.time}
      icon="ios3d"
      title={item.title}
      meta={item.meta}
      preview={item.preview}
      isRemoving={item.isRemoving}
      testID={testID}
      actions={<RawMeshViewerActionsPopover {...item.actionsProps} />}
      onClick={item.handleClick}
    />
  );
};
